import { createTheme } from "@mui/material/styles";

// Theme configurations for different modes
const themeConfigs = {
  light: {
    palette: {
      mode: "light",
      primary: {
        main: "#15C5BB",
        contrastText: "#ffffff",
      },
      secondary: {
        main: "#10968F",
        contrastText: "#ffffff",
      },
      background: {
        default: "#f5f5f5",
        paper: "#ffffff",
      },
      text: {
        primary: "#333333",
        secondary: "#666666",
      },
      action: {
        selected: "#e3f2fd",
        hover: "#f0f8ff",
      },
    },
  },
  dark: {
    palette: {
      mode: "dark",
      primary: {
        main: "#15C5BB",
        contrastText: "#ffffff",
      },
      secondary: {
        main: "#10968F",
        contrastText: "#ffffff",
      },
      background: {
        default: "#031716",
        paper: "#031716",
      },
      text: {
        primary: "#ffffff",
        secondary: "#cccccc",
      },
      action: {
        selected: "#0C6863",
        hover: "#063A36",
      },
    },
  },
  highContrast: {
    palette: {
      mode: "light",
      primary: {
        main: "#000000",
        contrastText: "#ffffff",
      },
      secondary: {
        main: "#ffffff",
        contrastText: "#000000",
      },
      background: {
        default: "#ffffff",
        paper: "#ffffff",
      },
      text: {
        primary: "#000000",
        secondary: "#000000",
      },
      action: {
        selected: "#000000",
        hover: "#000000",
      },
      divider: "#000000",
    },
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            border: "2px solid #000000",
            borderRadius: "4px",
            fontWeight: "bold",
            textTransform: "none",
          },
        },
      },
      MuiCard: {
        styleOverrides: {
          root: {
            border: "2px solid #000000",
            borderRadius: "4px",
          },
        },
      },
      MuiTextField: {
        styleOverrides: {
          root: {
            "& .MuiOutlinedInput-root": {
              border: "2px solid #000000",
              borderRadius: "4px",
            },
          },
        },
      },
      MuiListItemButton: {
        styleOverrides: {
          root: {
            border: "1px solid #000000",
            borderRadius: "4px",
            margin: "2px 0",
            "&:hover": {
              backgroundColor: "#000000 !important",
              color: "#ffffff !important",
              border: "2px solid #000000",
            },
            "&.Mui-selected": {
              backgroundColor: "#000000 !important",
              color: "#ffffff !important",
              border: "2px solid #000000",
            },
            "&.Mui-focusVisible": {
              backgroundColor: "#000000 !important",
              color: "#ffffff !important",
              border: "3px solid #000000",
            },
          },
        },
      },
      MuiListItem: {
        styleOverrides: {
          root: {
            "& .MuiListItemButton-root": {
              border: "1px solid #000000",
              borderRadius: "4px",
              margin: "2px 0",
              "&:hover": {
                backgroundColor: "#000000 !important",
                color: "#ffffff !important",
                border: "2px solid #000000",
              },
              "&.Mui-selected": {
                backgroundColor: "#000000 !important",
                color: "#ffffff !important",
                border: "2px solid #000000",
              },
            },
          },
        },
      },
      MuiList: {
        styleOverrides: {
          root: {
            "& .MuiListItem-root": {
              marginBottom: "4px",
            },
          },
        },
      },
      MuiListItemText: {
        styleOverrides: {
          root: {
            "& .MuiTypography-root": {
              fontWeight: "bold",
            },
          },
        },
      },
      MuiListItemIcon: {
        styleOverrides: {
          root: {
            color: "inherit",
            minWidth: "40px",
          },
        },
      },
    },
  },
};

// Function to create theme based on mode
export const createAppTheme = (mode = 'dark') => {
  const config = themeConfigs[mode] || themeConfigs.dark;
  
  return createTheme({
    ...config,
    typography: {
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
      fontSize: mode === 'highContrast' ? 16 : 14,
      fontWeightMedium: mode === 'highContrast' ? 600 : 500,
    },
    shape: {
      borderRadius: mode === 'highContrast' ? 4 : 8,
    },
    spacing: 8,
  });
};

// Default theme for backward compatibility
export const theme = createAppTheme('dark');

export default theme;
